import { TUsOnlyNoticeKind, TUsOnlyReviewNoticeKind } from '../constants/usOnlyNotice';

export const resolveUsOnlyNoticeKind = (hasMarketplace: boolean, hasGiftBudget: boolean): TUsOnlyNoticeKind | null => {
  if (hasMarketplace) {
    return 'marketplace';
  }

  return hasGiftBudget ? 'budget' : null;
};

export const resolveUsOnlyReviewNoticeKind = (
  hasMarketplace: boolean,
  hasGiftBudget: boolean,
): TUsOnlyReviewNoticeKind | null => {
  if (hasMarketplace && hasGiftBudget) {
    return 'both';
  }

  return resolveUsOnlyNoticeKind(hasMarketplace, hasGiftBudget);
};
